// *********** Customer CRUD Action Type ***********

// Create New Customer "Create"
export const ADD_NEW_SINGLE_CUSTOMER = "ADD_NEW_SINGLE_CUSTOMER";
export const ADD_SINGLE_CUSTOMER_SUCCESS = "ADD_SINGLE_CUSTOMER_SUCCESS";
export const ADD_SINGLE_CUSTOMER_FAIL = "ADD_SINGLE_CUSTOMER_FAIL";

// GET Customer data "Read"
export const GET_SINGLE_CUSTOMERS_DATA = "GET_SINGLE_CUSTOMERS_DATA";
export const GET_SINGLE_CUSTOMERS_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMERS_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMERS_DATA_FAIL = "GET_SINGLE_CUSTOMERS_DATA_FAIL";

// Update Customer "Update"
export const UPDATE_SINGLE_CUSTOMER = "UPDATE_SINGLE_CUSTOMER";
export const UPDATE_SINGLE_CUSTOMER_SUCCESS = "UPDATE_SINGLE_CUSTOMER_SUCCESS";
export const UPDATE_SINGLE_CUSTOMER_FAIL = "UPDATE_SINGLE_CUSTOMER_FAIL";

// Delete Customer "Delete"
export const DELETE_SINGLE_CUSTOMER = "DELETE_SINGLE_CUSTOMER";
export const DELETE_SINGLE_CUSTOMER_SUCCESS = "DELETE_SINGLE_CUSTOMER_SUCCESS";
export const DELETE_SINGLE_CUSTOMER_FAIL = "DELETE_SINGLE_CUSTOMER_FAIL";

// *********** Customer LIST Action Type ***********

// GET Customer List data "Read"
export const GET_SINGLE_CUSTOMERS_LIST_DATA = "GET_SINGLE_CUSTOMERS_LIST_DATA";
export const GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMERS_LIST_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL =
  "GET_SINGLE_CUSTOMERS_LIST_DATA_FAIL";

// Customer Balance List data "Read"

export const GET_CUSTOMER_BALANCE_LIST_DATA = "GET_CUSTOMER_BALANCE_LIST_DATA";
export const GET_CUSTOMER_BALANCE_LIST_DATA_SUCCESS =
  "GET_CUSTOMER_BALANCE_LIST_DATA_SUCCESS";
export const GET_CUSTOMER_BALANCE_LIST_DATA_FAIL =
  "GET_CUSTOMER_BALANCE_LIST_DATA_FAIL";

// Create New Customer "Create"
export const CREATE_NEW_SINGLE_CUSTOMER = "CREATE_NEW_SINGLE_CUSTOMER";
export const CREATE_SINGLE_CUSTOMER_SUCCESS = "CREATE_SINGLE_CUSTOMER_SUCCESS";
export const CREATE_SINGLE_CUSTOMER_FAIL = "CREATE_SINGLE_CUSTOMER_FAIL";

// Single Customer Activities List
export const GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA =
  "GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA";
export const GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL =
  "GET_SINGLE_CUSTOMER_ACTIVITIES_LIST_DATA_FAIL";

// Single Customer Site Location List
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA";
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_LIST_DATA_FAIL";

// Get Single Customer Site Location Data
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA";
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL =
  "GET_SINGLE_CUSTOMER_SITE_LOCATION_DATA_FAIL";

// Add New Customer Site Location
export const ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION =
  "ADD_NEW_SINGLE_CUSTOMER_SITE_LOCATION";
export const ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS =
  "ADD_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS";
export const ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL =
  "ADD_SINGLE_CUSTOMER_SITE_LOCATION_FAIL";

// update Single Customer Site Location
export const UPDATE_SINGLE_CUSTOMER_SITE_LOCATION =
  "UPDATE_SINGLE_CUSTOMER_SITE_LOCATION";
export const UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS =
  "UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS";
export const UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL =
  "UPDATE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL";

// Delete Single Customer Site Location
export const DELETE_SINGLE_CUSTOMER_SITE_LOCATION =
  "DELETE_SINGLE_CUSTOMER_SITE_LOCATION";
export const DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS =
  "DELETE_SINGLE_CUSTOMER_SITE_LOCATION_SUCCESS";
export const DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL =
  "DELETE_SINGLE_CUSTOMER_SITE_LOCATION_FAIL";

// Single Customer UrlLink tab list
export const SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA =
  "SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA";
export const SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS =
  "SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_SUCCESS";
export const SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL =
  "SEARCH_SINGLE_CUSTOMER_URL_LINK_LIST_DATA_FAIL";

// Single Customer UrlLink Details
export const GET_SINGLE_CUSTOMER_URL_LINK_DETAILS =
  "GET_SINGLE_CUSTOMER_URL_LINK_DETAILS";
export const GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS =
  "GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_SUCCESS";
export const GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL =
  "GET_SINGLE_CUSTOMER_URL_LINK_DETAILS_FAIL";

// Single Customer UrlLink Create
export const CREATE_SINGLE_CUSTOMER_URL_LINK =
  "CREATE_SINGLE_CUSTOMER_URL_LINK";
export const CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS =
  "CREATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS";
export const CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL =
  "CREATE_SINGLE_CUSTOMER_URL_LINK_FAIL";

// Single Customer UrlLink Update
export const UPDATE_SINGLE_CUSTOMER_URL_LINK =
  "UPDATE_SINGLE_CUSTOMER_URL_LINK";
export const UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS =
  "UPDATE_SINGLE_CUSTOMER_URL_LINK_SUCCESS";
export const UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL =
  "UPDATE_SINGLE_CUSTOMER_URL_LINK_FAIL";

// Single Customer UrlLink Delete
export const DELETE_SINGLE_CUSTOMER_URL_LINK =
  "DELETE_SINGLE_CUSTOMER_URL_LINK";
export const DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS =
  "DELETE_SINGLE_CUSTOMER_URL_LINK_SUCCESS";
export const DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL =
  "DELETE_SINGLE_CUSTOMER_URL_LINK_FAIL";

//Customer Url Link Status List
export const GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA =
  "GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA";
export const GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS =
  "GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_SUCCESS";
export const GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL =
  "GET_CUSTOMER_URL_LINK_STATUS_LIST_DATA_FAIL";

// Customer Url Link Status Details
export const GET_CUSTOMER_URL_LINK_STATUS_DETAILS =
  "GET_CUSTOMER_URL_LINK_STATUS_DETAILS";
export const GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS =
  "GET_CUSTOMER_URL_LINK_STATUS_DETAILS_SUCCESS";
export const GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL =
  "GET_CUSTOMER_URL_LINK_STATUS_DETAILS_FAIL";

// Customer Url Link Status Create
export const CREATE_CUSTOMER_URL_LINK_STATUS =
  "CREATE_CUSTOMER_URL_LINK_STATUS";
export const CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS =
  "CREATE_CUSTOMER_URL_LINK_STATUS_SUCCESS";
export const CREATE_CUSTOMER_URL_LINK_STATUS_FAIL =
  "CREATE_CUSTOMER_URL_LINK_STATUS_FAIL";

// Customer Url Link Status Update
export const UPDATE_CUSTOMER_URL_LINK_STATUS =
  "UPDATE_CUSTOMER_URL_LINK_STATUS";
export const UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS =
  "UPDATE_CUSTOMER_URL_LINK_STATUS_SUCCESS";
export const UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL =
  "UPDATE_CUSTOMER_URL_LINK_STATUS_FAIL";

// Customer Url Link Status Delete
export const DELETE_CUSTOMER_URL_LINK_STATUS =
  "DELETE_CUSTOMER_URL_LINK_STATUS";
export const DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS =
  "DELETE_CUSTOMER_URL_LINK_STATUS_SUCCESS";
export const DELETE_CUSTOMER_URL_LINK_STATUS_FAIL =
  "DELETE_CUSTOMER_URL_LINK_STATUS_FAIL";

// Customer Url Link Type List
export const GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA =
  "GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA";
export const GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS =
  "GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_SUCCESS";
export const GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL =
  "GET_CUSTOMER_URL_LINK_TYPE_LIST_DATA_FAIL";

// Customer Url Link Type Details
export const GET_CUSTOMER_URL_LINK_TYPE_DETAILS =
  "GET_CUSTOMER_URL_LINK_TYPE_DETAILS";
export const GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS =
  "GET_CUSTOMER_URL_LINK_TYPE_DETAILS_SUCCESS";
export const GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL =
  "GET_CUSTOMER_URL_LINK_TYPE_DETAILS_FAIL";

// Customer Url Link Type Create
export const CREATE_CUSTOMER_URL_LINK_TYPE = "CREATE_CUSTOMER_URL_LINK_TYPE";
export const CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS =
  "CREATE_CUSTOMER_URL_LINK_TYPE_SUCCESS";
export const CREATE_CUSTOMER_URL_LINK_TYPE_FAIL =
  "CREATE_CUSTOMER_URL_LINK_TYPE_FAIL";

// Customer Url Link Type Update
export const UPDATE_CUSTOMER_URL_LINK_TYPE = "UPDATE_CUSTOMER_URL_LINK_TYPE";
export const UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS =
  "UPDATE_CUSTOMER_URL_LINK_TYPE_SUCCESS";
export const UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL =
  "UPDATE_CUSTOMER_URL_LINK_TYPE_FAIL";

// Customer Url Link Type Delete
export const DELETE_CUSTOMER_URL_LINK_TYPE = "DELETE_CUSTOMER_URL_LINK_TYPE";
export const DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS =
  "DELETE_CUSTOMER_URL_LINK_TYPE_SUCCESS";
export const DELETE_CUSTOMER_URL_LINK_TYPE_FAIL =
  "DELETE_CUSTOMER_URL_LINK_TYPE_FAIL";

//Get Customers debit balance list
export const GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA =
  "GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA";
export const GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS =
  "GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_SUCCESS";
export const GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL =
  "GET_CUSTOMERS_DEBIT_BALANCE_LIST_DATA_FAIL";

//Get Customers overdue balance list
export const GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA =
  "GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA";
export const GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS =
  "GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_SUCCESS";
export const GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL =
  "GET_CUSTOMERS_OVERDUE_BALANCE_LIST_DATA_FAIL";

// Get customers balance List
export const GET_CUSTOMERS_BALANCE_LIST_ALL_DATA =
  "GET_CUSTOMERS_BALANCE_LIST_ALL_DATA";
export const GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS =
  "GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_SUCCESS";
export const GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL =
  "GET_CUSTOMERS_BALANCE_LIST_ALL_DATA_FAIL";

//Transactions_New Customer transactions list
export const CLEAR_CUSTOMER_TRANSACTIONS_LIST =
  "CLEAR_CUSTOMER_TRANSACTIONS_LIST";
export const CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS =
  "CLEAR_CUSTOMER_TRANSACTIONS_LIST_SUCCESS";
export const CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL =
  "CLEAR_CUSTOMER_TRANSACTIONS_LIST_FAIL";

// Search Single Customer External Ids list
export const SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA =
  "SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA";
export const SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS =
  "SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_SUCCESS";
export const SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL =
  "SEARCH_SINGLE_CUSTOMER_EXTERNAL_IDS_LIST_DATA_FAIL";

// Get Single Customer External Ids Details
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_SUCCESS";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_DETAILS_FAIL";

// Create Single Customer External Ids
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS";
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS";
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL";

// Update Single Customer External Ids
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS";
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS";
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL";

// Delete Single Customer External Ids
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS";
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_SUCCESS";
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_FAIL";

// Get Single Customer External Ids ExternalIdentificationProvider List
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_LIST_DATA_FAIL";

// Get Single Customer External Ids ExternalIdentificationProvider Details
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_SUCCESS";
export const GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL =
  "GET_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_DETAILS_FAIL";

// Create Single Customer External Ids ExternalIdentificationProvider
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER";
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS";
export const CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL =
  "CREATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL";

// Update Single Customer External Ids ExternalIdentificationProvider
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER";
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS";
export const UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL =
  "UPDATE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL";

// Delete Single Customer External Ids ExternalIdentificationProvider
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER";
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_SUCCESS";
export const DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL =
  "DELETE_SINGLE_CUSTOMER_EXTERNAL_IDS_EXTERNAL_IDENTIFICATION_PROVIDER_FAIL";

//Customer Status List
export const GET_CUSTOMER_STATUS_LIST_DATA = "GET_CUSTOMER_STATUS_LIST_DATA";
export const GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS =
  "GET_CUSTOMER_STATUS_LIST_DATA_SUCCESS";
export const GET_CUSTOMER_STATUS_LIST_DATA_FAIL =
  "GET_CUSTOMER_STATUS_LIST_DATA_FAIL";

//Customer Status Details
export const GET_CUSTOMER_STATUS_DETAILS = "GET_CUSTOMER_STATUS_DETAILS";
export const GET_CUSTOMER_STATUS_DETAILS_SUCCESS =
  "GET_CUSTOMER_STATUS_DETAILS_SUCCESS";
export const GET_CUSTOMER_STATUS_DETAILS_FAIL =
  "GET_CUSTOMER_STATUS_DETAILS_FAIL";

//Customer Status Create
export const CREATE_CUSTOMER_STATUS = "CREATE_CUSTOMER_STATUS";
export const CREATE_CUSTOMER_STATUS_SUCCESS = "CREATE_CUSTOMER_STATUS_SUCCESS";
export const CREATE_CUSTOMER_STATUS_FAIL = "CREATE_CUSTOMER_STATUS_FAIL";

//Customer Status Update
export const UPDATE_CUSTOMER_STATUS = "UPDATE_CUSTOMER_STATUS";
export const UPDATE_CUSTOMER_STATUS_SUCCESS = "UPDATE_CUSTOMER_STATUS_SUCCESS";
export const UPDATE_CUSTOMER_STATUS_FAIL = "UPDATE_CUSTOMER_STATUS_FAIL";

//Customer Status Delete
export const DELETE_CUSTOMER_STATUS = "DELETE_CUSTOMER_STATUS";
export const DELETE_CUSTOMER_STATUS_SUCCESS = "DELETE_CUSTOMER_STATUS_SUCCESS";
export const DELETE_CUSTOMER_STATUS_FAIL = "DELETE_CUSTOMER_STATUS_FAIL";

//Customer Type List
export const GET_CUSTOMER_TYPE_LIST_DATA = "GET_CUSTOMER_TYPE_LIST_DATA";
export const GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS =
  "GET_CUSTOMER_TYPE_LIST_DATA_SUCCESS";
export const GET_CUSTOMER_TYPE_LIST_DATA_FAIL =
  "GET_CUSTOMER_TYPE_LIST_DATA_FAIL";

//Customer Type Details
export const GET_CUSTOMER_TYPE_DETAILS = "GET_CUSTOMER_TYPE_DETAILS";
export const GET_CUSTOMER_TYPE_DETAILS_SUCCESS =
  "GET_CUSTOMER_TYPE_DETAILS_SUCCESS";
export const GET_CUSTOMER_TYPE_DETAILS_FAIL = "GET_CUSTOMER_TYPE_DETAILS_FAIL";

//Customer Type Create
export const CREATE_CUSTOMER_TYPE = "CREATE_CUSTOMER_TYPE";
export const CREATE_CUSTOMER_TYPE_SUCCESS = "CREATE_CUSTOMER_TYPE_SUCCESS";
export const CREATE_CUSTOMER_TYPE_FAIL = "CREATE_CUSTOMER_TYPE_FAIL";

//Customer Type Update
export const UPDATE_CUSTOMER_TYPE = "UPDATE_CUSTOMER_TYPE";
export const UPDATE_CUSTOMER_TYPE_SUCCESS = "UPDATE_CUSTOMER_TYPE_SUCCESS";
export const UPDATE_CUSTOMER_TYPE_FAIL = "UPDATE_CUSTOMER_TYPE_FAIL";

//Customer Type Delete
export const DELETE_CUSTOMER_TYPE = "DELETE_CUSTOMER_TYPE";
export const DELETE_CUSTOMER_TYPE_SUCCESS = "DELETE_CUSTOMER_TYPE_SUCCESS";
export const DELETE_CUSTOMER_TYPE_FAIL = "DELETE_CUSTOMER_TYPE_FAIL";

///thirdpartymailchimp/export/contacts
export const EXPORT_CONTACTS = "EXPORT_CONTACTS";
export const EXPORT_CONTACTS_SUCCESS = "EXPORT_CONTACTS_SUCCESS";
export const EXPORT_CONTACTS_FAIL = "EXPORT_CONTACTS_FAIL";

///customer/search
export const SEARCH_CUSTOMER = "SEARCH_CUSTOMER";
export const SEARCH_CUSTOMER_SUCCESS = "SEARCH_CUSTOMER_SUCCESS";
export const SEARCH_CUSTOMER_FAIL = "SEARCH_CUSTOMER_FAIL";

///customerbalancehistorical/availabledates
export const GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES =
  "GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES";
export const GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS =
  "GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_SUCCESS";
export const GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL =
  "GET_CUSTOMER_BALANCE_HISTORICAL_AVAILABLE_DATES_FAIL";

///customerbalancehistorical/specificdate/
export const GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE =
  "GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE";
export const GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS =
  "GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_SUCCESS";
export const GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL =
  "GET_CUSTOMER_BALANCE_HISTORICAL_SPECIFIC_DATE_FAIL";

///customerbalancehistorical/listbycustomer/ — monthly snapshots for one customer
export const GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER =
  "GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER";
export const GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS =
  "GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL =
  "GET_CUSTOMER_BALANCE_HISTORICAL_BY_CUSTOMER_FAIL";

///customernote/search
export const SEARCH_CUSTOMER_NOTE = "SEARCH_CUSTOMER_NOTE";
export const SEARCH_CUSTOMER_NOTE_SUCCESS = "SEARCH_CUSTOMER_NOTE_SUCCESS";
export const SEARCH_CUSTOMER_NOTE_FAIL = "SEARCH_CUSTOMER_NOTE_FAIL";
///customernote/create
export const CREATE_CUSTOMER_NOTE = "CREATE_CUSTOMER_NOTE";
export const CREATE_CUSTOMER_NOTE_SUCCESS = "CREATE_CUSTOMER_NOTE_SUCCESS";
export const CREATE_CUSTOMER_NOTE_FAIL = "CREATE_CUSTOMER_NOTE_FAIL";
